module.exports = __webpack_public_path__ + "static/media/idesam_recorte.8fb69d4e.png";